import React, { CSSProperties } from "react";
import { fontSizeType, fontWeightType } from "../types/type";

interface CustomTextProps {
  children?: React.ReactNode;
  marginTop?: number | string;
  marginBottom?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
  className?: string;
  weight?: fontWeightType;
  size?: fontSizeType;
  color?: string;
  spacing?: number | string;
  style?: CSSProperties;
  textAlign?:
    | "left"
    | "right"
    | "center"
    | "justify"
    | "inherit"
    | "initial"
    | "unset";
}

function CustomText({
  children,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  className,
  size,
  weight,
  color,
  spacing,
  style,
  textAlign,
}: CustomTextProps) {
  let fontSize: string;

  switch (size) {
    case "xxsmall":
      fontSize = "font10";
      break;
    case "xsmall":
      fontSize = "font12";
      break;
    case "small":
      fontSize = "font14";
      break;
    case "smallMedium":
      fontSize = "font16";
      break;
    case "medium":
      fontSize = "font18";
      break;
    case "mediumLarge":
      fontSize = "font20";
      break;
    case "large":
      fontSize = "font24";
      break;
    case "xlarge":
      fontSize = "font28";
      break;
    case "xxlarge":
      fontSize = "font32";
      break;
    case "xxxlarge":
      fontSize = "font64";
      break;
    case "prize":
      fontSize = "fontPrize";
      break;
    default:
      fontSize = "font14";
  }

  return (
    <p
      className={`font ${fontSize} ${className}`}
      style={{
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
        fontWeight: weight,
        letterSpacing: spacing,
        textAlign: textAlign,
        color: color,
        ...style,
      }}
    >
      {children}
    </p>
  );
}

export default CustomText;
